<template>
    <div key="checkoffAttachment">
        <b-modal v-model="isVisible" hide-footer class="pt-8" header-class="p-0" content-class="custom-model-wrap" name="$translate('uploaded_file')">
            <template #modal-title="{ cancel }">
                <div class="title-block text-center p-2">{{ $translate('uploaded_file') }}</div>
                <div class="close-btn" @click="cancel()">×</div>
            </template>
            <b-img :src="newModel.url" v-if="['jpg', 'jpeg', 'png'].includes(
                newModel && newModel.file_extension
            )" fluid alt="Responsive image"></b-img>
            <a v-else-if="['xls', 'xlsx'].includes(
                newModel && newModel.file_extension
            )
                " :href="newModel && newModel.url">
                <div class="btn btn-success btn-sm">
                    <i class="fa-solid fa-file-excel fa-2x"></i>
                </div>
            </a>
            <a v-else-if="newModel && newModel.file_extension == 'pdf'" :href="newModel && newModel.url">
                <div class="btn delete-button btn-sm">
                    <i class="fa fa-file-pdf fa-2x"></i>
                </div>
            </a>
            <a v-else :href="newModel && newModel.url">
                <div class="btn btn-success btn-sm">
                    <i class="fa fa-file fa-2x"></i>
                </div>
            </a>

            <br />
            <div class="row px-3">
                <b-list-group class="mt-2 col-12 col-sm-9">
                    <b-list-group-item class="d-inline-flex p-2">
                        <!--file name input to rename the file before upload-->
                        <b-form-input :disabled="viewMode && !isNew" :placeholder="$translate('file_name_placeholder')" v-model="newModel.name" required />
                        <!--file extension-->
                        <span class="d-inline-flex align-items-center text-muted ml-1 mr-3">.{{ newModel.file_extension
                        }}</span>
                    </b-list-group-item>
                </b-list-group>
                <b-col cols="12" sm="3" class="align-self-center pt-2">
                    <b-button type="submit" variant="info" :disabled="viewMode && !isNew" class="btn-fw" @click="renameFileName(newModel.index, newModel.name)">
                        {{ $translate('rename') }}
                    </b-button>
                </b-col>
            </div>
            <div class="text-center mt-3">
                <b-button variant="delete-button" class="btn-fw ms-2"  :disabled="viewMode && !isNew" v-if="hasPermissionDelete"
                    @click="deleteAttachment(newModel.id)">{{ $deleteLabel() }}</b-button>

            </div>
        </b-modal>
        <div>
            <b-row v-if="!checkoff.completed">
                <b-col cols="12">
                    <b-form-file id="uploadCheckoffData" @change="uploadCheckoffFile"></b-form-file>
                </b-col>
            </b-row>
            <b-container fluid class="p-4 mt-4 bg-light">
                <b-overlay :show="submitting" rounded="sm" >
                    <b-row>
                    <b-col v-for="(item, index) in attachments" :key="index" md="2" class="mt-2 mt-md-0">
                            <button v-if="['jpg', 'jpeg', 'png'].includes(
                                item.file_extension
                            )" @click="setModel(item, index)">
                                <b-img :height="imageHeight" :width="imageWidth" :src="item.url" alt="Image 1"></b-img>
                            </button>
                            <button v-else-if="['xls', 'xlsx'].includes(
                                item.file_extension
                            )
                                " @click="setModel(item, index)">
                                <div class="btn btn-success btn-sm">
                                    <i class="fa-solid fa-file-excel fa-2x"></i>
                                </div>
                            </button>
                            <button v-else-if="item.file_extension == 'pdf'" @click="setModel(item, index)">
                                <div class="btn delete-button btn-sm">
                                    <i class="fa-solid fa-file-pdf fa-2x"></i>
                                </div>
                            </button>
                            <button v-else @click="setModel(item, index)">
                                <div class="btn btn-success btn-sm">
                                    <i class="fa fa-file fa-2x"></i>
                                </div>
                            </button>
                            <div>
                                <label>{{ item.name ? item.name + '.' + item.file_extension : '' }}</label><br>
                                <div class="mt-1 mb-2" v-if="item.updated_at">
                                    <label><b>{{ $translate('upload_on') }}</b></label>
                                    <label>{{ item.created_at | displayTime }}</label>
                                </div>
                            </div>
                        </b-col>
                        <b-col v-if="!attachments.length">
                            <h4 class="text-black">{{ $translate('no_attachments_submitted') }}</h4>
                        </b-col>
                    </b-row>
                </b-overlay>
            </b-container>
        </div>
    </div>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'orders-ViewCheckoffAttachments',
    mixins: [popupMixins, permissionsMixins],
    props: {
        order_id: { type: Number}, 
        order_checkoff_id: { type: Number},
        viewMode: { type: Boolean, default: false },
    },
    data() {
        return {
            submitting: false,
            model: null,
            imageHeight: 80,
            imageWidth: 80,
            currentIndex: -1,
            isVisible: false,
            newModel: {
                "name": null,
            },
        }
    },
    computed: {
        isVisible_fn() {
            return this.currentIndex >= 0
        },
        attachments() {
            const attachments = this.checkoff.checkoff_attachments
            console.log(attachments)
            return attachments
        },

        mediaBaseUrl() {
            return this.$store.getters['mediaBaseUrl']
        },

        checkoff() {
            return this.checkoffs.find(
                x => x.id === this.order_checkoff_id
            )
        },

        order() {
            return this.$store.state.orders.item
        },

        checkoffs() {
            const item = this.$store.state.orders.checkoffs
            console.log('computed---checkoffs', item)
            return item || {}
        },
    },
    filters: {
        displayTime(date) {
            var retutnTime = 'N/A'
            if (date != '') {
                const utc = date.split(' ').join('T').split('.')[0] + '.000Z'
                retutnTime = new Date(utc).toLocaleString()
            }
            return retutnTime
            // const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
            // console.log('timezone', timezone)
            // if (date) {
            //     return new Date(date).toLocaleString('en-US', {
            //         timeZone: timezone,
            //     })
            // } else {
            //     return ''
            // }
        },

    },
    watch: {
        currentIndex: function (index) {
            if (index >= 0) {
                const item = this.attachments[index]
                console.log(this.attachments)
                console.log('item', item)
                this.model = {}
                for (const key in item) {
                    this.$set(this.model, key, item[key])
                }
            }
        },
    },
    mounted() {
        this.$store.dispatch('js_report/fetchCredentials')
    },
    methods: {
        async uploadCheckoffFile(event) {
            this.submitting = true
            let allowedTypes = ['docx', 'pdf', 'doc', 'png', 'jpg', 'jpeg', 'xls', 'xlsx'] //allowed upload filetypes array  
            let uploadedFileName = event.target.files[0].name;
            let fileExtension = uploadedFileName.split('.').pop();
            let maxFileSize = this.$maxFileSize
            console.log("event.target.files", event.target.files)
            if (!allowedTypes.includes(fileExtension.toLowerCase())) {
                this.doToast(this.$translate('error'), this.$translate('invalid_file_type_review'), 'danger')
                this.submitting = false
                return false;
            }
            if (maxFileSize < event.target.files[0].size) {
                this.doToast(this.$translate('error'), this.$translate('file_size_alert'), 'danger')
                this.submitting = false
                return false
            }
            console.log('uploadCheckoff event', event)

            try {
                this.submitting = true
                console.log(event.target.files)

                const { key, name } = await this.$store.dispatch(
                    's3files/s3singleUpload',
                    event.target.files
                )

                const { order_id: id, order_checkoff_id } = this
                const url = `${this.mediaBaseUrl}/${key}`
                const file_name = event.target.files[0].name
                console.log({ key, name, url })
                console.log({
                    id,
                    order_checkoff_id,
                    url,
                })
                //   if (chkPnt === 1) throw new Error('Aborted')
                await this.$store.dispatch('orders/addCheckoffAttachment', {
                    id,
                    order_checkoff_id,
                    url,
                    name: file_name.replace(/\.[^/.]+$/, ''),
                    file_extension: file_name.split('.').pop(),
                })

                this.genericToast(
                    this.$translate('activity_review'),
                    this.$translate('updated'),
                    'success',
                    this.$translate(`checkoff_attachment_added`)
                )

                // this.$emit('attachment-added', order_checkoff_id)
            } catch (error) {
                console.error('addAttachement', error)
                this.doToast(this.$translate('error'), this.$translate('error_adding_attachment'), 'danger')
            } finally {
                this.submitting = false
           }
        },

        deleteAttachment(attachment_id) {
            const title = this.$translate('delete_attachment')
            const message = `${this.$translate('delete_note')} ${this.$translate('attachments')}?`
            this.confirmMessage(title, message).then(result => {
                if (!result) return
                this.submitting = true
                const { order_id: id, order_checkoff_id } = this
                this.$store
                    .dispatch('orders/deleteCheckoffAttachment', {
                        id,
                        order_checkoff_id,
                        attachment_id,
                    })
                    .then(() => {
                        this.genericToast(
                            this.$translate('checkoff_attachment'),
                            this.$translate('deleted'),
                            'success',
                            `${this.$translate('checkoff_attachment')} ${this.$translate('delete_alert')}`
                        )

                        this.currentIndex = -1
                        this.isVisible = false
                    })
                    .catch(error => {
                        console.error(error)
                        this.doToast(
                            this.$translate('error'),
                            this.$translate('unable_alert'),
                            'danger'
                        )
                    })
                    .finally(() => {
                        this.submitting = false
                    })
            })
        },
        renameFileName(fileIndex, newName) {
            const file = this.attachments[fileIndex]
            if (!newName) {
                this.doToast(this.$translate('error'), this.$translate('file_name_required'), 'danger')
                return false
            }
            file.name = newName
            if (file.id) {
                this.$store.dispatch('orders/renameCheckoffAttachment', {
                    file,
                })
                this.isVisible = false
                this.genericToast(
                    this.$translate('activity_review'),
                    this.$translate('updated'),
                    'success',
                    this.$translate(`checkoff_attachment_renamed`)
                )
            } else {
                this.attachments[fileIndex] = file
                this.updateAttachment(this.attachments)
                this.isVisible = false
            }
        },
        setModel(item, i) {
            this.newModel = { ...item, index: i }
            this.isVisible = true
        },
    },
}
</script>

<style lang="scss" scoped></style>
